import "./PathTopic.css"
import PathTopicDetails from "./PathTopicDetails"

const PathTopic = ({ item }) => (
  <div className="PathTopic">
    <PathTopicDetails item={item} />
  </div>
)

PathTopic.displayName = "PathTopic"

export default PathTopic
